import { render, staticRenderFns } from "./TblSelfTest.vue?vue&type=template&id=2545a180"
import script from "./TblSelfTest.vue?vue&type=script&lang=js"
export * from "./TblSelfTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports